import React, { useEffect, useState, useContext } from "react";
import { TrafficContext } from "../../App";
import '../../universal.css';
import { METARS_URL, orderedAirports } from '../../data/config';

const METAR = () => {
  const [metars, setMetars] = useState([]);
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('metarMode') || "SELECT";
  });
  const [selectedAirport, setSelectedAirport] = useState(() => {
    return localStorage.getItem('selectedMetarAirport') || "EFHK";
  });
  const traffic = useContext(TrafficContext);

  useEffect(() => {
    const fetchMETARs = async () => {
      try {
        const response = await fetch(`${METARS_URL}`, {
          cache: 'no-store'
        });
        let data = await response.json();

        if (mode === "AUTO") {
          const icaoSet = new Set(
            traffic
              .map((pilot) => {
                const departure = pilot.flight_plan.departure;
                const arrival = pilot.flight_plan.arrival;
                return [departure, arrival];
              })
              .flat()
              .filter((icao) => icao.startsWith("EF"))
          );
          data = data.filter((m) => icaoSet.has(m.icao));
        } else if (mode === "SELECT") {
          data = data.filter((m) => m.icao === selectedAirport);
        }

        setMetars(data);
      } catch (error) {
        console.error("Error fetching METARs:", error);
      }
    };

    if (mode !== "NONE") {
      fetchMETARs();
      const interval = setInterval(fetchMETARs, 60000);
      return () => clearInterval(interval);
    }
  }, [mode, selectedAirport, traffic]);

  useEffect(() => {
    localStorage.setItem('metarMode', mode);
  }, [mode]);

  useEffect(() => {
    localStorage.setItem('selectedMetarAirport', selectedAirport);
  }, [selectedAirport]);

  // Function to highlight specific patterns in the METAR text
  const highlightMETAR = (text) => {
    const windPattern = /(\d{5}KT|\d{5}KTG\d{2}|VRB\d{2}KT)/g;
    const windPattern2 = /(\d{3}V\d{3})/g;
    const gustingWindPattern = / (\d{3}\d{2}G\d{2}KT) /g;
    const qnhPattern = /(Q\d{4})/g;
    const icaoPattern = /(EF[A-Z]{2}\s)/g;

    return text
    .replace(windPattern, '<span class="highlight">$1</span>')
    .replace(windPattern2, '<span class="highlight">$1</span>')
    .replace(gustingWindPattern, ' <span class="highlight">$1</span> ')
    .replace(qnhPattern, '<span class="highlight">$1</span>')
    .replace(icaoPattern, '<span class="highlight">$1</span>');
  };

  return (
    <div className="bg-gray-300 text-white h-full">
      <div className="flex space-x-2 bg-gray-300 w-full text-xs">
        <button className={`p-1 ${mode === "AUTO" ? "bg-gray-600" : "bg-gray-400"}`} onClick={() => setMode("AUTO")}>
          AUTO
        </button>
        <button className={`p-1 ${mode === "ALL" ? "bg-gray-600" : "bg-gray-400"}`} onClick={() => setMode("ALL")}>
          ALL
        </button>
        <button className={`p-1 ${mode === "SELECT" ? "bg-gray-600" : "bg-gray-400"}`} onClick={() => setMode("SELECT")}>
          SELECT
        </button>
        <select
          className={`p-1 ${mode === "SELECT" ? "bg-gray-600" : "bg-gray-400"}`}
          onChange={(e) => setSelectedAirport(e.target.value)}
          value={selectedAirport}
          disabled={mode !== "SELECT"}
        >
          {orderedAirports.map((airport) => (
            <option key={airport.icao} value={airport.icao}>
              {airport.icao}
            </option>
          ))}
        </select>
      </div>
      <div className="overflow-y-auto text-black text-xs monospace-font mt-1 pb-8 h-full">
        {metars.length === 0 ? (
          <p>No METAR data available</p>
        ) : (
          metars.map((m) => (
            <p key={m.icao} className="table-line p-1" dangerouslySetInnerHTML={{ __html: highlightMETAR(m.metar) }} />
          ))
        )}
      </div>
    </div>
  );
};

export default METAR;
